import React, { Component } from "react";
import tick from "../assets/tick.svg";
import reject from "../assets/reject.svg";
import { connect } from "react-redux";
import defaultPicture from "../assets/user.svg";
import API from "./Api";

const mapStateToProps = (state) => ({
  headers: state.headers(),
});

export default connect(mapStateToProps)(
  class teamMember extends Component {
    data = this.props.data;
    state = {
      isLoading: false,
    };
    loader = () => {
      this.setState({ isLoading: !this.state.isLoading });
    };
    acceptInvite = () => {
      const body = {};
      API.post(`business/teams/invites/${this.data.identifier}/approve`, body, {
        headers: this.props.headers,
      }).then(
        ({ data }) => {
          this.props.refresh();
          this.loader();
          if (data.success) window.$.notify("Invite Approved", "success-alert");
        },
        ({ response }) => {}
      );
    };
    rejectInvite = () => {
      const body = {};
      API.post(`business/teams/invites/${this.data.identifier}/reject`, body, {
        headers: this.props.headers,
      }).then(
        ({ data }) => {
          this.props.refresh();
          this.loader();
          if (data.success) window.$.notify("Invite Rejected", "success-alert");
        },
        ({ response }) => {}
      );
    };

    render() {
      return (
        <div className="team-member flex space-btw">
          <div className="left flex ">
            <span
              className="dp-rapper"
              style={{
                backgroundImage: `url("${
                  this.data.profile_picture || defaultPicture
                }")`,
              }}
            ></span>
            <p className="name">
              {this.data.first_name} {this.data.last_name}
            </p>
          </div>
          <div className="right btns">
            <button
              onClick={(ev) => {
                this.loader(ev.currentTarget);
                this.acceptInvite();
              }}
              is-loading={this.state.isLoading.toString()}
            >
              <img src={tick} alt="" srcSet="" />
            </button>
            <button
              onClick={(ev) => {
                this.loader(ev.currentTarget);
                this.rejectInvite();
              }}
              is-loading={this.state.isLoading.toString()}
            >
              <img src={reject} alt="" srcSet="" />
            </button>
          </div>
        </div>
      );
    }
  }
);
